import { CustomerGroup } from "./customer.type";
import { PurchaseOrderChain } from "./purchase-order.type";

/**
 * The file layouts a modern-trade chain export can be rendered in (`customer_groups.export_format`).
 * A new chain on one of these layouts is configuration only; a new layout needs a new endpoint.
 */
export type CustomerGroupExportFormat = "tesco" | "seven_eleven" | "twk";

export const CUSTOMER_GROUP_EXPORT_FORMATS: CustomerGroupExportFormat[] = [
  "tesco",
  "seven_eleven",
  "twk",
];

export const CUSTOMER_GROUP_EXPORT_FORMAT_LABEL: Record<CustomerGroupExportFormat, string> = {
  tesco: "Tesco",
  seven_eleven: "7-Eleven",
  twk: "TWK",
};

/** The MT chain export + PO settings block — `PUT /customer-groups/:uuid/export-settings` (MASTER). */
export interface CustomerGroupExportSettings {
  export_format: CustomerGroupExportFormat | null;
  export_file_prefix: string | null;
  export_site_length: number | null;
  export_doc_type: string | null;
  export_vat_branch_no: string | null;
  po_chain: PurchaseOrderChain | null;
  po_customer_code_prefixes: string[] | null;
}

/** A row of `GET /customer-groups` with the vendor and export settings the API returns. */
export interface CustomerGroupWithExportSettings
  extends CustomerGroup,
    CustomerGroupExportSettings {
  vendor_code: string | null;
  vendor_name: string | null;
}
